/**
 * Resource hints for optimizing asset loading
 * Implements DNS prefetch, preconnect, prefetch, and preload
 */

export function addDNSPrefetch(domains: string[]) {
  domains.forEach((domain) => {
    const link = document.createElement('link');
    link.rel = 'dns-prefetch';
    link.href = domain;
    document.head.appendChild(link);
  });
}

export function addPreconnect(domains: string[]) {
  domains.forEach((domain) => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = domain;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
}

export function prefetchRoute(path: string) {
  const link = document.createElement('link');
  link.rel = 'prefetch';
  link.href = path;
  document.head.appendChild(link);
}

export function preloadImage(src: string, priority: 'high' | 'low' = 'low') {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'image';
  link.href = src;
  link.fetchPriority = priority;
  document.head.appendChild(link);
}

export function preloadFont(href: string, type: string = 'font/woff2') {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'font';
  link.type = type;
  link.href = href;
  link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
}

// Initialize common resource hints
export function initializeResourceHints() {
  // DNS prefetch for external domains
  addDNSPrefetch([
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com',
  ]);

  // Preconnect to critical domains
  addPreconnect([
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com',
  ]);
}
